
import httpClient from "@/plugins/axios";
import { formatFormFields } from "@/@core/utils/form_helpers";

export const getFeedbacks = async () => {
    const response = await httpClient.get("/admin/v1/feedbacks/");
    return response;
}

// Paginated feedback list (v2)
// Query params:
// - page
// - page_size
// - status
// - category
export const getFeedbacksV2 = async ({ page = 1, pageSize = 10, status = null, category = null } = {}) => {
    const params = new URLSearchParams();
    if (page) params.set('page', String(page));
    if (pageSize) params.set('page_size', String(pageSize));
    if (status !== null && status !== undefined && status !== '') params.set('status', String(status));
    if (category !== null && category !== undefined && category !== '') params.set('category', String(category));

    const response = await httpClient.get(`/admin/v2/feedbacks/?${params.toString()}`);
    return response;
}

export const getFeedback = async (id) => {
    const response = await httpClient.get(`/admin/v1/feedback/${id}/`);
    return response;
}

export const saveFeedbackMessage = async (id, message) => {
    const response = await httpClient.post(`/admin/v1/feedback/${id}/messages`, {
        text: message
    });
    return response;
}

export const updateFeedback = async (feedback) => {
    const response = await httpClient.put(`/admin/v1/feedback/${feedback.id}/`, feedback);
    return response;
}

export const getFeedbackCount = async (status) => {
    const response = await httpClient.get(`/admin/v1/feedbacks/count/?status=${status}`);
    return response;
}

export const downloadLegacyFeedbackAttachment = async (feedbackId) => {
    const response = await httpClient.get(`/admin/v1/feedback/${feedbackId}/attachment`,
        {
            responseType: 'blob',
        });

    return response;
}

export const downloadFeedbackAttachment = async (feedbackId, attachmentId) => {
    const response = await httpClient.get(`/admin/v1/feedback/${feedbackId}/attachments/${attachmentId}/`,
        {
            responseType: 'blob',
        });

    return response;
}

export const getFeedbackManagers = async () => {
    const response = await httpClient.get(`/admin/v1/feedback-managers/`);
    return response;
}

export const addFeedbackManager = async (manager) => {
    const response = await httpClient.post(`/admin/v1/feedback-managers/`, manager);

    return response;
}

export const updateFeedbackManager = async (manager) => {
    const response = await httpClient.put(`/admin/v1/feedback-managers/${manager.user}/`, manager);

    return response;
}

export const removeFeedbackManager = async (managerId) => {
    const response = await httpClient.delete(`/admin/v1/feedback-managers/${managerId}/`);
    return response;
}

export const getFeedbackManagerLog = async () => {
    const response = await httpClient.get(`/admin/v1/feedback-managers/log/`);
    return response;
}

export const getFeedbackCategories = async () => {
    const response = await httpClient.get(`/admin/v1/feedback/categories/`);
    return response;
}

// Admin reports
export const getFeedbackPerCategoryWeeklyReport = async ({ month = null } = {}) => {
    const params = new URLSearchParams();
    if (month) params.set('month', String(month));

    const qs = params.toString();
    const url = qs
        ? `/admin/v2/reports/feedbacks/per-category-weekly/?${qs}`
        : `/admin/v2/reports/feedbacks/per-category-weekly/`;

    const response = await httpClient.get(url);
    return response;
}

export const exportFeedbackCategorySubmissions = async (categoryId = null, filters = null) => {
    const params = {};
    if (categoryId !== null && categoryId !== undefined) {
        params.category = categoryId;
    }
    if (filters) {
        params.filters = filters;
    }

    const response = await httpClient.get(
        `/admin/v1/feedbacks/export/`,
        {
            params: params,
            responseType: 'blob',
        }
    );
    return response;
}

export const getFeedbackCategory = async (id) => {
    const response = await httpClient.get(`/admin/v1/feedback/categories/${id}/`);
    return response;
}

export const saveFeedbackCategory = async (category) => {
    // Format form fields to filter out invalid translations (fields without labels)
    const payload = { ...category };
    if (payload.form && payload.form.fields) {
        payload.form = {
            ...payload.form,
            fields: formatFormFields(payload.form.fields),
        };
    }

    if (payload.id) {
        const response = await httpClient.put(`/admin/v1/feedback/categories/${payload.id}/`, payload);
        return response;
    }
    else {
        const response = await httpClient.post(`/admin/v1/feedback/categories/`, payload);
        return response;
    }
}
